import React, {Component} from 'react';
import Title from '../generics/Title';
import {translate} from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import swal from 'sweetalert';
import moment from 'moment';
import Notifications, {notify} from 'react-notify-toast';

import Petition from './Components/petition';

var Config = require('../../../config');

class NewPetition extends Component{
	constructor(props){
		super(props);

		this.onSave = this.onSave.bind(this);
		this.regresar = this.regresar.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.getValues = this.getValues.bind(this);
		this.getTableUnits = this.getTableUnits.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.state = {
			petition_type:"",
			disabledFields: false,
			id:"",
			petitions:[],
			required_fields:[],
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'form_fields_required/?key=petition',{
			method: 'get',
		    headers: new Headers({
		       'Authorization'	: 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept'			: 'application/json',
		       'Content-Type'	: 'application/json',
		    })
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				response.fields_required.map((res)=>{
					this.setState({required_fields: [...this.state.required_fields, res]});
				})
			}
		})

		fetch(Config.default.apiGateway.URL+'petition_type?option=active', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({petitions:response});
			}
		});

		if(this.props.match.params.id !== undefined){
			this.getValues();
		}
	}

	getValues(){
		this.setState({id:this.props.match.params.id });
		

		this.props.waiting.handleShow('Cargando...');
	
		setTimeout(()=>{
			this.petition.getPlasmaticProduct();
		}, 500);

		this.getTableUnits();
		
		fetch(Config.default.apiGateway.URL+'petitions?id='+this.props.match.params.id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				
				setTimeout(()=>{
					this.petition.setState({apheresis_fields_values: [], plasmaticAdded: []})// response.petition_apheresis_values});	
					
					var index = this.state.petitions.findIndex(obj =>
						obj.id === response.petition.petition_type_id
					);
					this.petition.getPetition(this.state.petitions[index].name);
					
					if(this.petition.state.pet_fam_res.value === 'YES'){
						if(response.petition_family_responsable !== null){
							this.petition.modal_familiar.setState({
								id:response.petition_family_responsable.id,
								name:response.petition_family_responsable.full_name,
								relationship:response.petition_family_responsable.patient_relationship,
								address:response.petition_family_responsable.address,
								state:response.petition_family_responsable.state,
								mpio:response.petition_family_responsable.province,
								cp:response.petition_family_responsable.cp,
								tel_cel:response.petition_family_responsable.home_phone,
								tel_casa:response.petition_family_responsable.cell_phone,
								hb:response.petition_family_responsable.hemoglobina,
								hto:response.petition_family_responsable.hematocrito,
							})
						}
							
					}

					if(this.state.petitions[index].type === 'COMPONENTS'){
						this.petition.setState({petition:'COMPONENTS'});
						this.petition.clearValues();
						this.petition.getPetitionType('COMPONENTS');
						
						
					}else if(this.state.petitions[index].type === 'URGENT_COMPONENTS'){
						this.petition.setState({petition:'URGENT_COMPONENTS'});
						this.petition.clearValues();
						this.petition.getPetitionType('URGENT_COMPONENTS');
						
						
					}else if(this.state.petitions[index].type === 'APHERESIS'){
						this.petition.setState({petition:'APHERESIS', show_details:true});
						this.petition.getPetitionType('APHERESIS');
						this.petition.clearValues();
					}else if(this.state.petitions[index].type === 'PLASMATIC_PRODUCTS'){
						//this.petition.clearValues();
						this.petition.setState({petition:'PLASMATIC_PRODUCTS'});
						
						this.petition.getPetitionType('PLASMATIC_PRODUCTS');
						
						
					}else{
						this.petition.setState({petition:'LABORATORY'});
						this.petition.getPetitionType('LABORATORY');
						this.petition.clearValues();
						this.petition.getAnaliticalTest();
						this.petition.getAnaliticalProfile();
						if(this.petition._typeahead_test !== undefined && this.petition._typeahead_test !== null){
							if(this.petition._typeahead_test.getInstance() !== null){
								this.petition._typeahead_test.getInstance().clear();
							}
						}
						if(this.petition._typeahead_profile !== undefined && this.petition._typeahead_profile !== null){
							if(this.petition._typeahead_profile.getInstance() !== null){
								this.petition._typeahead_profile.getInstance().clear();
							}
						}
					}

					
					this.petition.setState({
						patient_id: response.patient.id,
						person_id:response.person.id,
						patient_number: response.patient.patient_number,
						patient_name: response.person.names,
						patient_lastname1: response.person.lastname1,
						patient_lastname2: response.person.lastname2,
						clinic_history: response.petition.clinic_history,
						social_number: response.person.social_number,
						disableFields: true,
						lookup_group: response.person.lookup_group,
						lookup_rh: response.person.lookup_rh,
						document_type: response.documents.length > 0 ? response.documents[0].document_type : "",
						document_number: response.documents.length > 0 ? response.documents[0].document_number : "",
						birthdate: response.person.birthday !== null ? moment(response.person.birthday).format('DD/MM/YYYY') : '',
						age:response.patient_age,
						age_type:response.petition.age_type,
						patient_sex:response.person.sex,
						lectina:response.lectina,
						du:response.du,
						doctor_lastname1:response.petition.doctor_lastname1,
						doctor_lastname2:response.petition.doctor_lastname2,
						cedula_doctor:response.petition.cedula_medico,
						petition_status:response.petition.status,
						work_sessions_id:response.petition.work_sessions_id,
						flag_condition: response.flag_conditions
					})

					if(response.person.birthday !== null){
						var control = document.getElementById('birthdate');
						//this.petition.calcularEdad(response.person.birthday, control);
					}

					var phen = '';
					response.phenotype.map((p, i)=>{
						phen += p.phenotype1+p.result+( i === response.phenotype.length -1 ? '' : ', ')
					})

					var anti = "";
					response.antibodys.map((a, i)=>{
						if(a.result === '1'){
							anti += a.antibody+( i === response.antibodys.length -1 ? '' : ', ')
						}	
					})

					this.petition.setState({phenotypes: phen, antibodys:anti});


					this.petition.specialFields(0, 1);
	
					setTimeout(()=>{
						this.petition.setState({
							special_values: response.special_fields_values
						});

						this.petition.setAnswers(response.special_fields_values)
					}, 500);
						
					this.petition.setState({
						petition_id: response.petition.id,						
						date: response.petition.petition_date !== null ? 
							moment(response.petition.petition_date, 'YYYY-MM-DD').format('YYYY-MM-DD') : "",
						hour: response.petition.petition_hour !== null ? 
							moment(response.petition.petition_hour, 'HH:mm:ss').format('HH:mm') : "",
						petition_number: response.petition.petition_number !== "" ? response.petition.petition_number : "",
						petition_episodio: response.petition.episodio !== null ? response.petition.episodio : "",
						petition_ubication: response.petition.ubication !== "" ? response.petition.ubication : "",
						petition_doctor: response.petition.doctor !== "" ? response.petition.doctor : "",
						petition_component_priority: response.petition.priority !== null ? response.petition.priority : "",
						solicited_date: response.petition.pickup_date !== null ? moment(response.petition.pickup_date.split('T')[0]).format('YYYY-MM-DD') : "",
						petition_diagnosis: response.petition.diagnosis !== null ? response.petition.diagnosis : "",
						petition_observations: response.petition.observations !== "" ? response.petition.observations : "",
						//origin_center_id: response.petition.origin_center_id,
						health_services: response.petition.health_services,
						petition_reason: response.petition.reason !== null ? response.petition.reason : "",
						petition_consentimiento: response.petition.consentimineto_informado !== null ? response.petition.consentimineto_informado : "",
						petition_previal_transfution: response.petition.previal_transfution,
						flag_samples:response.flag_samples,
						list_unit_reserved:response.list_units_reserved,
						list_unit_delivered:response.list_units_delivered,
						last_date_send:response.last_unit_delivered,
						petition_history:response.petitions
					});

					if(response.last_rai !== null){
						this.petition.setState({
							rai: response.last_rai.value,
							rai_date: moment(response.last_rai.timestamp).format('DD/MM/YYYY HH:mm')
						})
					}

					if(response.petition.previal_transfution !== null && response.petition.previal_transfution !== "" && response.petition.previal_transfution !== "NO"){
						document.getElementById('petition_previal_transfution').checked = true;
					}

					if(response.petition.consentimineto_informado !== null && response.petition.consentimineto_informado !== "" && response.petition.consentimineto_informado !== "NO"){
						document.getElementById('petition_consentimiento').checked = true;
					}

					if(response.petition.origin_center_id !== undefined){
						var index = this.petition.state.health_facilities.findIndex(obj => 
							obj.id === response.petition.origin_center_id
						);
						if(index !== -1){
							this.petition.setState({
								indice: 0,
								requestedSelected:[this.petition.state.health_facilities[index]],
								origin_center_id: response.petition.origin_center_id,
							})
						}
					}


					if(response.maternal_test.length > 0){
						this.petition.setState({
							maternal_test_id: response.maternal_test[0].id,
							maternal_test_ultima_regla: response.maternal_test[0].ultima_regla !== null ?
														moment(response.maternal_test[0].ultima_regla).format('YYYY-MM-DD') : "",
							maternal_test_gestational_week: response.maternal_test[0].gestational_week || "",
							maternal_test_gestational_day: response.maternal_test[0].gestational_day || "",
							maternal_test_expected_birthday: response.maternal_test[0].expected_birth || "",
							maternal_test_no_fetus: response.maternal_test[0].no_fetus || "",
							maternal_test_profilaxis: response.maternal_test[0].prophylaxis ? 'SI' :
														!response.maternal_test[0].prophylaxis ? 'NO' : "",
							maternal_test_profilaxis_date: response.maternal_test[0].prophylaxis_date !== null ?
														 response.maternal_test[0].prophylaxis_date.split('T')[0] : "",
							maternal_test_child_alive: response.maternal_test[0].child_alive || '0',
							maternal_test_child_dead: response.maternal_test[0].child_dead !== 0 ? response.maternal_test[0].child_dead : '0',
							maternal_test_abortions: response.maternal_test[0].abortions !== 0 ? response.maternal_test[0].abortions : '0',
						});
					}

					response.petition_aferesis.map((af)=>{
						var index = this.petition.state.petition_aferesis.findIndex(obj => obj.key === af.process_type);
						
						if(index !== -1){
							this.petition.setState({
								process_type_id: af.id,
								process_type: this.petition.state.petition_aferesis[index].key
							});
						}
							
					});

					response.petitions_blood_components.map((comp)=>{

						this.petition.setState({
							petition_components: [
								...this.petition.state.petition_components, {
									id: comp.id,
									petitions_id: comp.petitions_id,
									amount: comp.amount,
									component_type: comp.component_type,
									informed_consent: comp.informed_consent,
									previous_transfusions: comp.previous_transfusions,
									priority: comp.priority,
									solicitedfor_date: comp.solicitedfor_date,
									solicitedfor_hour: comp.solicitedfor_hour,
									surgery_type: comp.surgery_type,
								}
							]
						});

						if(comp.solicitedfor_hour !== "" && comp.solicitedfor_hour !== null){
							this.petition.setState({
								solicited_hour: moment(comp.solicitedfor_hour, 'h:mm').format('h:mm')
							});
								
						}
					});

					
					response.petition_products.map((prod)=>{
						
						var index = this.petition.state.plasmatic_products.findIndex(obj => obj.id === prod.plasmatic_product_id);
					
						if(index !== -1){
							this.petition.setState({
								plasmaticAdded: [
									...this.petition.state.plasmaticAdded, {
										id_plasmatic: prod.id,
										id: this.petition.state.plasmatic_products[index].id,
										name: this.petition.state.plasmatic_products[index].name,
										amount: prod.amount
									}
								]
							});
						}
					});

					response.petition_study.map((pet)=>{
						return this.petition.setState({
							analitical_profile_person_id:pet.analytic_profile_person_id,
							petition_study_id:pet.id,
							petition_study1:pet.petition_study1
						});
					});

					//this.petition.getAnaliticalTest();
					//this.petition.getAnaliticalProfile();
					setTimeout(()=>{
						response.petition_lab.map((lab)=>{
							if(lab.analitical_test_id && lab.analytic_profile_person_id === null){
								this.petition.setState({
									solicitud_type: 'PRUEBA'
								});
								
							}else if(lab.analytic_profile_person_id !== null){
								this.petition.setState({
									solicitud_type: 'PERFIL'
								});

								
							}

							var index_test = this.petition.state.analitical_list.findIndex(obj => obj.analitical_test.id === lab.analitical_test_id);
							var index_profile = this.petition.state.profile_list.findIndex(obj => obj.profile.id === lab.analytic_profile_person_id);
							
							if(index_test !== -1){
								this.petition.setState({
									list_test: [
										...this.petition.state.list_test,
										{
											id: lab.analitical_test_id,
											lab_id: lab.id,
											petition_id: lab.petition_id,
											name: this.petition.state.analitical_list[index_test].analitical_test.name,
											check: true
										}
									],
								});
							}
							
							if(index_profile !== -1){
								/*this.petition.setState({
									index_profile: index_profile
								});*/
								this.petition.setState({
									index_profile: 0,
									profile_selected:[this.petition.state.profile_list[index_profile]]
								})
							}	
						});
					}, 500);

					if(this.props.location.pathname.indexOf('view') !== -1){
						this.setState({disabledFields:true});
						this.petition.setState({disableFields:true});
					}

				}, 500);
			}
		})
	}

	getTableUnits(){
		fetch(Config.default.apiGateway.URL+'petitions/table_units?id='+this.props.match.params.id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.petition.setState({
					list_components: response
				});

				if(response.length > 0){
					this.setState({disabledFields:true});
				}
					
			}
		});
	}

	onSave(){
		var errorFecha = this.isValidDate();
		var method = "";
		var api = "";

		if(this.validBirthdate()){
			if(errorFecha === ''){
				if(this.isValidForm()){

					var patient = this.petition.getDataPatient();
					if(patient === null)//si se generó un error al adquirir los datos del paciente, cancelar proceso de guardado
						return;
					var petition = this.petition.getDataForm();
					var answers = this.petition.getAnswers();
					//var petition_apheresis_values = this.petition.getAnswersApheresis();
					var pet_fam_res = this.petition.state.petition_family_responsable;
					
					petition.patient_id = patient.id;
					petition.clinic_history = patient.number;
					petition.health_facilities_id = sessionStorage.getItem('health_facilities_id');
					
					var obj = {};
					obj.patient = patient;
					obj.petition= petition;
					obj.answers = answers;
					//obj.petition_apheresis_values = petition_apheresis_values;
					obj.sample_id = this.petition.state.sample_selected_id;
					if(this.petition.state.pet_fam_res.value === 'YES'){
						obj.petition_family_responsable = pet_fam_res;	
					}				

					if(obj.petition.id !== ""){
						method = 'PUT';
						api = 'petitions/'+obj.petition.id;
					}else{
						method = 'POST';
						api = 'petitions';
					}

					if(patient.person.names === "" ){
						swal('Error', 'No se han ingresado datos del paciente', 'error');
					}else if(petition.petitions_blood_components !== undefined && petition.petitions_blood_components.length === 0){
						swal('Error', 'Debe de ingresar al menos un componente', 'error');
					}else if(petition.origin_center_id === ""){
						swal('Error', 'Debe seleccionar un origen valido', 'error');
						document.getElementById('origin_center_id').classList.add('error');
						this.petition._typeahead_origin.getInstance().clear();
					}else{
						this.props.waiting.handleShow('Guardando');
						fetch(Config.default.apiGateway.URL+api, {
							method: method,
							body: JSON.stringify(obj),
							headers: new Headers({
								'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
								'Accept'		: 'application/json',
								'Content-Type'	: 'application/json'
							})
						}).then(res => {
							this.props.waiting.handleClose();
							if(res.ok){
								return method === 'POST' ? res.json() : 'correcto';
								//return 'correcto';
							}else{

								res.text().then(function(msg){
									swal("Error", msg, 'error');
								});
							}
						}).then(response => {
							if(response !== undefined){
								swal('Correcto', 'Registro guardado correctamente.', 'success');
								if(response === 'correcto'){
									this.props.history.push('/petition_register');
								}else{
									this.props.history.push('/petition_register/edit/'+response.petition.id);
									this.getValues();
								}
								
							}
						});
					}
						
				}else{
					swal("Error", "Campos incompletos", 'error');
				}
			}else{
				notify.show('Error, '+errorFecha,'error');
			}
		}else{
			swal('Error', 'La Fecha de Nacimiento del paciente no puede ser mayor a la fecha de hoy', 'error');
		}				
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input,textarea');
	    let isFormValid = true;
		var vacio = false;
		

	    inputs.forEach(input => {
			var index = this.state.required_fields.findIndex(obj => 
				(obj.table.toUpperCase() === this.petition.state.petition ||
				obj.table.toUpperCase() === 'PATIENT') &&
	    		obj.field.toUpperCase() === input.id.toUpperCase()
	    	);
	    	
	    	if(index !== -1){
    			var control = document.getElementById(input.id);

    			if(control !== null){
    				if(control.value === ""){

						control.classList.add('error');
			        	vacio = true;
			        	
					}else{
						if(control.className.includes('error')){
							control.classList.remove('error');
						}
					}

    			}
	    	}else{
	    		if(input.required){
			      	const isInputValid = this.showCtrlError(input.id);
			      	if (!isInputValid) {
			        	vacio = true;
			    	}
			  	}
	    	}

	    });

	    if(vacio){
	    	isFormValid = false;
	    }


	    return isFormValid;
	}

	removeValidation(){
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		var control = document.getElementById(input.name);
	    		if(control !== null){
	    			control.classList.remove('error');
	    		}
	    		
		  	}
	    });
	}

	isValidDate(){
		var msg = '';
		
		var f_nacimiento = moment(this.petition.state.birthdate, 'DD-MM-YYYY');
		var f_form =  moment(this.petition.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');

		var validPatient = f_nacimiento.format('MM-DD-YYYY');
		var validForm = f_form.format('MM-DD-YYYY');

		
		if(validPatient === 'Invalid date' && this.petition.state.birthdate !== ''){
			msg += 'Fecha de Nacimiento, ';
		}

		if(validForm === 'Invalid date' && this.petition.state.date !== ''){
			msg += 'Fecha Petición ';
		}

		if(msg === ''){
			return msg;
		}else{
			msg += 'no válida';
			return msg;
		}	
	}

	validBirthdate(){
		var f_form =  moment(this.petition.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');

		var birth = moment(this.petition.state.birthdate,'DD-MM-YYYY');
		var date_ok = true;

		if(f_form !== 'Invalid date' && birth !== 'Invalid date'){
			if(f_form < birth){
				date_ok = false;
			}
		}else{
			date_ok = false;
		}		

		return date_ok;

	}

	//desplegar errores en selceted
	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if(this.petition.state[refName] === undefined){
			if(control !== null){
				if(control.required){
					if(control.value === ""){
						control.classList.add('error');
			        	res = false;
			        	
					}else{
						if(control.className.includes('error')){
							control.classList.remove('error');	
						}
						res = true;
					}
				}
		    }
			
		}else if (this.petition.state[refName] === "") {
	        if(control !== null){
	        	if(control.value === ""){
	           		control.classList.add('error');
	           		res = false;
	           	}else{
	           		if(control.className.includes('error')){
						control.classList.remove('error');
					}
					res = true;
					
	           	}
	        }
			
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
		        	control.classList.remove('error');
		    	}
		    	res = true;
	    	}
			
		}

		return res;
		
	}

	regresar(){
		this.props.history.goBack();
		//this.props.history.push('/petition_register');
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null){
    					form.elements[index + 1].focus();
    				
    				}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 2].focus();
    				
    				}

    				if(form.elements[index + 1].getAttribute("name") === null){
						form.elements[index + 2].focus();
    				}

    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	clearValues(){
  		if(this.petition !== undefined && this.petition !== null){
  			this.petition.setState({
				petition_number	: "",
				petition_id: "",
				petition_episodio 	 :"",
				petition_ubication	 :"",
				petition_doctor		 :"",
				petition_observations:"",
				petition_diagnosis   :"",
				petition_reason 	 :"",

				plasmatic_products: [],
				plasmatic_product_id:"",
				plasmatic_product_amount:"",
				
				origin_center_id:"",

				health_services	  :"",
				
				maternal_test_ultima_regla	 	:"",
				maternal_test_gestational_week 	:"",
				maternal_test_gestational_day	:"",
				maternal_test_expected_birthday	:"",
				maternal_test_no_fetus		 	:"",
				maternal_test_profilaxis 		:"",
				maternal_test_profilaxis_date	:"",
				maternal_test_child_alive		:"",
				maternal_test_child_dead		:"",
				maternal_test_abortions		 	:"",

				petition_components:[],
				
				solicited_date: "",
				solicited_hour: "",

				previous_transfutions:[],
				previous_transfutions_name:"",
				petition_previal_transfution:"",

				petition_consentimiento:"",
				petition_component_priority:"",
				petition_component_surgery_type:"",

				analitical_profile_person_id:"",
				process_type:"", 
				solicitud_type:"",

				blood_component_type:"",
				blood_component_amount:"",
				componentsAdded:[],

				isLoading:false,
				analitical_list: [],
				list_test:[],
				test:"",
				profile:""
			})
  		}		
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12 form-group">
				<Title {...this.props} onRef={ref => (this.title = ref)} />
				<form noValidate>
					<Petition {...this.props} state={this.state}
						validate={this.validateInput}
						onRef={ref => this.petition = ref}
						showCtrlError={this.showCtrlError}
						isValidForm={this.isValidForm}
						changePolitransfused={this.changePolitransfused}
						disabledFields={this.state.disabledFields}
						getValues={this.getValues}
						getTableUnits={this.getTableUnits}
						onSave={this.onSave}
						regresar={this.regresar}
					/>					

				</form>
				<Notifications />
			</div>
		)
	}
}

export default translate('translations') (NewPetition);